import React from "react"
import {FieldManagementPreviewProps} from "../../render/management-preview";
import FieldView from "../../render/view";

export default function FieldProto_ManagementPreview(props:FieldManagementPreviewProps) {

    return <FieldView field={props.field} model={props.field.previewModel} />

    // return (
    //     <div className="ui5-txt-default ui5-txt-red">{props.field.type}.managementPreview</div>
    // )

}